const _excluded = ["color"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import styled from 'styled-components';
import { Icon } from '@cbhq/cds-web/icons/Icon';
import { media } from '../../breakpoints.js';
import { ScreenReaderOnly } from '../ScreenReaderOnly.js';
import { useCarouselContext } from './useCarouselContext.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';

/* eslint-disable @cbhq/react-no-untranslated-string -- TODO Fix this */
const CAROUSEL_BUTTON_SIZE = 32;
function CarouselButtons(_ref) {
  let color = _ref.color,
    props = _objectWithoutProperties(_ref, _excluded);
  const _useCarouselContext = useCarouselContext(),
    activeSlideIndex = _useCarouselContext.activeSlideIndex,
    numberOfSlides = _useCarouselContext.numberOfSlides,
    hideButtonsOnEdges = _useCarouselContext.hideButtonsOnEdges,
    paginate = _useCarouselContext.paginate;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [(!hideButtonsOnEdges || activeSlideIndex !== 0) && /*#__PURE__*/
    // eslint-disable-next-line react-perf/jsx-no-new-function-as-prop -- TODO Fix this
    jsxs(LeftButton, _objectSpread(_objectSpread({
      onClick: () => paginate(-1)
    }, props), {}, {
      children: [/*#__PURE__*/jsx(Icon, {
        size: "l",
        name: "caretLeft",
        color: color
      }), /*#__PURE__*/jsx(ScreenReaderOnly, {
        children: "Previous slide"
      })]
    })), (!hideButtonsOnEdges || activeSlideIndex !== numberOfSlides - 1) && /*#__PURE__*/
    // eslint-disable-next-line react-perf/jsx-no-new-function-as-prop -- TODO Fix this
    jsxs(RightButton, _objectSpread(_objectSpread({
      onClick: () => paginate(1)
    }, props), {}, {
      children: [/*#__PURE__*/jsx(Icon, {
        size: "l",
        name: "caretRight",
        color: color
      }), /*#__PURE__*/jsx(ScreenReaderOnly, {
        children: "Next slide"
      })]
    }))]
  });
}

// eslint-disable-next-line @cbhq/theme-no-static-value -- TODO Fix this
const CarouselButton = styled.button`
  position: absolute;
  padding-left: 0;
  padding-right: 0;

  top: 0;
  bottom: 0;

  margin-top: auto;
  margin-bottom: auto;
  background-color: transparent;
  z-index: 1;
  cursor: pointer;
  width: ${CAROUSEL_BUTTON_SIZE}px;
  height: ${CAROUSEL_BUTTON_SIZE}px;
`;
const LeftButton = styled(CarouselButton)`
  left: 0;

  ${media.md} {
    left: 16px;
  }

  ${media.lg} {
    left: 40px;
  }
`;
const RightButton = styled(CarouselButton)`
  right: 0;

  ${media.md} {
    right: 16px;
  }

  ${media.lg} {
    right: 40px;
  }
`;
export { CAROUSEL_BUTTON_SIZE, CarouselButtons };
//# sourceMappingURL=CarouselButtons.js.map
